<template>
  <q-page class="q-pa-md bg-grey-2">
    <!-- NAVEGACIÓN Y BREADCRUMBS -->
    <div class="row items-center justify-between q-mb-md wrap gap-sm">
      <q-breadcrumbs active-color="primary" style="font-size: 14px" class="q-py-xs">
        <q-breadcrumbs-el label="Inicio" icon="home" to="/aveo/Dashboard" />
        <q-breadcrumbs-el label="Empresas" icon="business" to="/aveo/Empresa/Lista" />
        <q-breadcrumbs-el :label="'Detalle: ' + ruc" icon="visibility" />
      </q-breadcrumbs>

      <q-btn
        outline
        color="primary"
        icon="arrow_back"
        label="Volver a Lista"
        no-caps
        class="bg-white"
        @click="$router.push('/aveo/Empresa/Lista')"
      />
    </div>

    <!-- Card de Información de Empresa -->
    <q-card class="q-mb-md shadow-2 rounded-borders">
      <q-card-section class="bg-primary text-white row items-center justify-between q-py-md wrap">
        <div class="text-h6 text-weight-bold row items-center q-py-xs">
          <q-icon name="business" class="q-mr-sm" size="sm" />
          Datos de la Empresa: {{ DatosEmpresa.razonsocial || 'Cargando...' }}
        </div>
        <q-btn
          flat
          round
          dense
          color="white"
          icon="edit"
          @click="$router.push('/aveo/Empresa/Nuevo/' + ruc)"
        >
          <q-tooltip>Editar Empresa</q-tooltip>
        </q-btn>
      </q-card-section>

      <q-card-section class="q-pa-md">
        <div class="row q-col-gutter-md">
          <div class="col-12 col-sm-3">
            <q-input v-model="DatosEmpresa.ruc" label="RUC" outlined dense disable />
          </div>
          <div class="col-12 col-sm-9">
            <q-input v-model="DatosEmpresa.razonsocial" label="Razón Social" outlined dense disable />
          </div>
        </div>

        <div class="row q-col-gutter-md q-mt-xs">
          <div class="col-12 col-sm-4">
            <q-input v-model="DatosEmpresa.representante" label="Representante" outlined dense disable />
          </div>
          <div class="col-12 col-sm-4">
            <q-input v-model="DatosEmpresa.telefono" label="Teléfono" outlined dense disable />
          </div>
          <div class="col-12 col-sm-4">
            <q-input v-model="DatosEmpresa.direccion" label="Dirección" outlined dense disable />
          </div>
        </div>

        <div class="row q-col-gutter-md q-mt-xs">
          <div class="col-12 col-sm-6">
            <q-input v-model="DatosEmpresa.descripcion" label="Descripción" outlined dense disable />
          </div>
          <div class="col-12 col-sm-6">
            <q-input v-model="DatosEmpresa.email" label="Email" outlined dense disable />
          </div>
        </div>
      </q-card-section>
    </q-card>

    <!-- Card de Servicios de la Empresa -->
    <q-card class="shadow-2 rounded-borders">
      <q-card-section class="bg-primary text-white row items-center justify-between q-py-md wrap">
        <div class="text-h6 text-weight-bold row items-center q-py-xs">
          <q-icon name="build" class="q-mr-sm" size="sm" />
          Servicios Asignados ({{ ListaArticulos.length }})
        </div>
        <q-btn
          color="white"
          text-color="primary"
          icon="add"
          label="Agregar Servicio"
          unelevated
          rounded
          no-caps
          class="text-weight-bold"
          @click="DialogNuevoServicio"
        />
      </q-card-section>

      <q-card-section class="q-pa-none">
        <q-table
          :data="ListaArticulos"
          :columns="columns"
          row-key="id"
          :grid="$q.screen.xs"
          flat
          bordered
          no-data-label="No hay servicios asignados a esta empresa"
        >
          <!-- Slot Grid para Móviles (Pantallas Celular) -->
          <template v-slot:item="props">
            <div class="q-pa-xs col-xs-12 col-sm-6">
              <q-card class="shadow-2 rounded-borders overflow-hidden bg-white">
                <q-card-section class="bg-grey-2 q-pa-sm row items-center justify-between">
                  <div>
                    <div class="text-subtitle1 text-weight-bold text-primary">{{ props.row.descripcion }}</div>
                    <div class="text-caption text-grey-7">Grupo: {{ props.row.grupo || '-' }}</div>
                  </div>
                  <div class="row items-center">
                    <q-badge
                      :color="props.row.estadoBool ? 'positive' : 'grey-7'"
                      class="q-mr-xs text-weight-bold"
                    >
                      {{ props.row.estadoBool ? 'VIGENTE' : 'ANULADO' }}
                    </q-badge>
                    <q-toggle
                      v-model="props.row.estadoBool"
                      color="primary"
                      dense
                      @input="Activar(props.row)"
                    />
                  </div>
                </q-card-section>

                <q-separator />

                <q-card-section class="q-pa-sm text-caption">
                  <div class="row q-col-gutter-xs items-center q-mb-xs">
                    <div class="col-6">
                      <span class="text-grey-7">Vencimiento: </span>
                      <strong class="text-primary">{{ props.row.vencimiento || '-' }}</strong>
                    </div>
                    <div class="col-6 text-right">
                      <q-chip
                        dense
                        size="sm"
                        :color="props.row.vencido === 'SI' ? 'negative' : 'positive'"
                        text-color="white"
                        class="text-weight-bold"
                      >
                        Vencido: {{ props.row.vencido || 'NO' }}
                      </q-chip>
                    </div>
                  </div>
                  <div class="row q-col-gutter-xs text-grey-8">
                    <div class="col-6">Obligatorio: <strong>{{ props.row.obligatorio || 'NO' }}</strong></div>
                    <div class="col-6 text-right">Propio: <strong>{{ props.row.propio || 'NO' }}</strong></div>
                  </div>
                  <div v-if="props.row.observaciones && props.row.observaciones !== '-'" class="q-mt-xs text-grey-8">
                    <strong>Obs:</strong> {{ props.row.observaciones }}
                  </div>
                </q-card-section>

                <q-separator />

                <q-card-actions class="row q-col-gutter-xs justify-end bg-grey-1 q-pa-xs">
                  <div :class="!props.row.vencimiento ? 'col-6' : 'col-12'">
                    <q-btn
                      outline
                      color="primary"
                      icon="edit"
                      label="Editar Vencimiento"
                      no-caps
                      dense
                      class="full-width text-weight-bold bg-white"
                      @click="EditarVencimiento(props.row)"
                    />
                  </div>
                  <div v-if="!props.row.vencimiento" class="col-6">
                    <q-btn
                      outline
                      color="negative"
                      icon="delete"
                      label="Eliminar Servicio"
                      no-caps
                      dense
                      class="full-width text-weight-bold bg-white"
                      @click="EliminarServicio(props.row)"
                    />
                  </div>
                </q-card-actions>
              </q-card>
            </div>
          </template>

          <!-- Estado Toggle Slot (Vista Escritorio) -->
          <template v-slot:body-cell-estado="props">
            <q-td :props="props" class="text-center">
              <q-badge
                :color="props.row.estadoBool ? 'positive' : 'grey-7'"
                class="q-mr-xs text-weight-bold"
              >
                {{ props.row.estadoBool ? 'VIGENTE' : 'ANULADO' }}
              </q-badge>
              <q-toggle
                v-model="props.row.estadoBool"
                color="primary"
                @input="Activar(props.row)"
              />
            </q-td>
          </template>

          <!-- Vencido Chip Slot (Vista Escritorio) -->
          <template v-slot:body-cell-vencido="props">
            <q-td :props="props" class="text-center">
              <q-chip
                dense
                :color="props.row.vencido === 'SI' ? 'negative' : 'positive'"
                text-color="white"
                class="text-weight-bold"
              >
                {{ props.row.vencido || 'NO' }}
              </q-chip>
            </q-td>
          </template>

          <!-- Acciones Slot (Vista Escritorio) -->
          <template v-slot:body-cell-actions="props">
            <q-td :props="props" class="text-right">
              <q-btn
                flat
                round
                dense
                color="primary"
                icon="edit"
                @click="EditarVencimiento(props.row)"
              >
                <q-tooltip>Editar Vencimiento</q-tooltip>
              </q-btn>
              <q-btn
                v-if="!props.row.vencimiento"
                flat
                round
                dense
                color="negative"
                icon="delete"
                @click="EliminarServicio(props.row)"
              >
                <q-tooltip>Eliminar Servicio</q-tooltip>
              </q-btn>
            </q-td>
          </template>
        </q-table>
      </q-card-section>
    </q-card>

    <!-- Modales -->
    <empresa-servicio-modal
      @CerrarModal="CerrarModalServicio"
      :DialogServicio="DialogServicio"
      :Servicio="DatosServicio"
    />
    <empresa-servicio-vencimiento
      @CerrarModal="CerrarModalVencimiento"
      :DialogServicio="DialogVencimiento"
      :ServicioVent="DatosVen"
    />
  </q-page>
</template>

<script>
import EmpresaServicioModal from "@/pages/Empresa/EmpresaNuevoServicio";
import EmpresaServicioVencimiento from "@/pages/Empresa/EmpresaVencimientoEditar";
import axios from "axios";

export default {
  name: "EmpresaDetallePage",
  components: { EmpresaServicioModal, EmpresaServicioVencimiento },
  data() {
    return {
      dialog: false,
      ruc: "",
      DialogServicio: false,
      DialogVencimiento: false,
      ListaArticulos: [],
      DatosEmpresa: {
        ruc: "",
        razonsocial: "",
        representante: "",
        telefono: "",
        direccion: "",
        descripcion: "",
        email: "",
      },
      DatosVen: {
        ruc: "",
        idServicioEmpresa: 0,
        descripcion: "",
        vencimiento: "",
        propio: "SI",
        estado: "V",
        observaciones: "",
      },
      DatosServicio: {
        ruc: "",
        idServicio: "",
        estado: "",
        diasaviso: "",
        descripcion: "",
        propio: "",
      },
      columns: [
        { name: "id", label: "Id", field: "id", align: "left", sortable: true },
        { name: "descripcion", label: "Descripción", field: "descripcion", align: "left", sortable: true },
        { name: "grupo", label: "Grupo / Alias", field: row => row.grupo || row.aliass || "-", align: "left" },
        { name: "obligatorio", label: "Obligatorio", field: row => row.obligatorio || "NO", align: "center" },
        { name: "propio", label: "Propio", field: row => row.propio || "NO", align: "center" },
        { name: "vencimiento", label: "Vencimiento", field: row => row.vencimiento || "-", align: "center", sortable: true },
        { name: "estado", label: "Estado", field: "estado", align: "center" },
        { name: "vencido", label: "Vencido", field: row => row.vencido || "NO", align: "center" },
        { name: "observaciones", label: "Observaciones", field: row => row.observaciones || "-", align: "left", sortable: true },
        { name: "actions", label: "Acciones", field: "actions", align: "right" },
      ],
    };
  },
  created() {
    this.ruc = this.$route.params.ruc || "";
    this.DatosEmpresa.ruc = this.ruc;
    this.GetEmpresa();
    this.GetLista();
  },
  methods: {
    DialogNuevoServicio() {
      this.DatosServicio.ruc = this.ruc;
      this.DialogServicio = true;
    },
    EditarVencimiento(item) {
      this.DatosVen.ruc = this.ruc;
      this.DatosVen.idServicioEmpresa = item.idservicioempresa;
      this.DatosVen.descripcion = item.descripcion;
      this.DatosVen.vencimiento = item.vencimiento;
      this.DatosVen.observaciones = item.observaciones || "";
      this.DialogVencimiento = true;
    },
    CerrarModalServicio() {
      this.DialogServicio = false;
      this.GetLista();
    },
    CerrarModalVencimiento() {
      this.DialogVencimiento = false;
      this.GetLista();
    },
    GetEmpresa() {
      let me = this;
      this.ruc = this.$route.params.ruc || this.ruc;
      axios.post("ApiWeb/EmpresaId.php", { ruc: this.ruc }, { params: { ruc: this.ruc } })
        .then((res) => {
          if (res.data && res.data.data) {
            me.DatosEmpresa = res.data.data;
          } else if (res.data && typeof res.data === "object") {
            me.DatosEmpresa = res.data;
          }
        })
        .catch((err) => console.error("Error GetEmpresa:", err));
    },
    GetLista() {
      let me = this;
      this.ruc = this.$route.params.ruc || this.ruc;
      axios.post("ApiWeb/EmpresaServicios.php", { ruc: this.ruc }, { params: { ruc: this.ruc } })
        .then((res) => {
          console.log(res);
          let rawData = [];
          if (res.data && Array.isArray(res.data.data)) {
            rawData = res.data.data;

          } else if (res.data && Array.isArray(res.data)) {
            rawData = res.data;
          }

          me.ListaArticulos = rawData.map((item) => ({
            ...item,
            grupo: item.grupo || item.aliass || "-",
            propio: item.propio || "NO",
            estado: item.estado || (item.vencido === "SI" ? "A" : "V"),
            estadoBool: item.estado ? item.estado === "V" : item.vencido !== "SI",
          }));
        })
        .catch((err) => console.error("Error GetLista:", err));
    },
    // Activar(item) {
    //   let me = this;
    //   let nuevoEstado = item.estadoBool ? "V" : "A";
    //   console.log(item);
    //   // Form Data is required for native PHP $_POST handling
    //   const formData = new FormData();
    //   formData.append("ruc", String(item.ruc || ""));
    //   formData.append("estado", String(nuevoEstado));
    //   formData.append("idServicioEmpresa", String(item.idservicioempresa || ""));
    //   formData.append("id", String(item.id || ""));
    //  console.log(Object.fromEntries(formData));
    //   axios.post("ApiWeb/EmpresaServicioActivar.php", formData)
    //     .then((res) => {
    //       if (res.data && res.data.error) {
    //         item.estadoBool = !item.estadoBool;
    //         if (me.$q && me.$q.notify) {
    //           me.$q.notify({
    //             message: res.data.mensaje || "Error al actualizar estado",
    //             color: "negative",
    //             position: "top-right",
    //             timeout: 3000
    //           });
    //         }
    //         return;
    //       }

    //       item.estado = nuevoEstado;
    //       if (me.$q && me.$q.notify) {
    //         me.$q.notify({
    //           message: nuevoEstado === "V" ? "Servicio Activado" : "Servicio Desactivado",
    //           color: nuevoEstado === "V" ? "positive" : "warning",
    //           position: "top-right",
    //           timeout: 2000
    //         });
    //       }
    //       me.GetLista();
    //     })
    //     .catch((err) => {
    //       console.error("Error Activar:", err);
    //       item.estadoBool = !item.estadoBool;
    //     });
    // },
    Activar(item) {
  let me = this;
  let nuevoEstado = item.estadoBool ? "V" : "A";

  const payload = {
    idServicioEmpresa: item.idservicioempresa,
    estado: nuevoEstado
  };

  axios.post("ApiWeb/EmpresaServicioActivar.php", payload)
    .then((res) => {
      if (res.data && res.data.error) {
        item.estadoBool = !item.estadoBool;
        if (me.$q && me.$q.notify) {
          me.$q.notify({
            message: res.data.mensaje || "Error al actualizar estado",
            color: "negative",
            position: "top-right",
            timeout: 3000
          });
        }
        return;
      }

      item.estado = nuevoEstado;
      if (me.$q && me.$q.notify) {
        me.$q.notify({
          message: nuevoEstado === "V" ? "Servicio Activado" : "Servicio Desactivado",
          color: nuevoEstado === "V" ? "positive" : "warning",
          position: "top-right",
          timeout: 2000
        });
      }
      me.GetLista();
    })
    .catch((err) => {
      console.error("Error Activar:", err);
      item.estadoBool = !item.estadoBool;
    });
}
,
    EliminarServicio(item) {
      if (confirm("¿Desea eliminar este servicio de la empresa?")) {
        let me = this;
        const formData = new FormData();
        formData.append("idServicioEmpresa", String(item.id || ""));
        axios.post("ApiWeb/EmpresaServicioEliminar.php", formData)
          .then(() => me.GetLista())
          .catch((err) => console.error("Error EliminarServicio:", err));
      }
    },
  },
};
</script>
